// Reserved note_id for the legacy hardcoded program "reflection" field that the
// patient app historically appended to every program. It is modelled as a
// PatientIcbtNote with this noteId in health-profiles. The legacy note keeps its
// own dedicated UI (the Notes list with the default question); other,
// Contentful-placed notes are rendered inline in the program page under their
// IcbtExerciseLabel. Must match LEGACY_NOTE_ID in health-profiles.
export const LEGACY_NOTE_ID = "legacy-program-reflection";
